import * as yup from 'yup';

const validationSchemaLogin = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  password: yup
    .string()
    .required('Please enter your password')
    .matches(
      /^\S{6,32}$/,
      'Invalid details. Please check the Email ID - Password combination.'
    ),
  reCaptchaCode: yup.string(),
});
const validationSchemaSignUpHirist = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  password: yup
    .string()
    .required('Please enter your password')
    .matches(/^\S{6,32}$/, 'Password must be 6-32 characters with no spaces'),
});

const validationSchemaSignUp = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  password: yup
    .string()
    .required('Please enter your password')
    .matches(/^\S{6,32}$/, 'Password must be 6-32 characters with no spaces'),
  // confirmPassword: yup
  //   .string()
  //   .required('Please enter your password')
  //   .oneOf(
  //     [yup.ref('password')],
  //     'The passwords you entered do not match. Please check and try again'
  //   ),
  policyCheck: yup
    .boolean()
    .required('Please agree to the terms and conditions to continue')
    .oneOf([true], 'Please agree to the terms and conditions to continue'),
});

const validationSchemaForgot = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  reCaptchaCode: yup.string(),
});

const validationSchemaOtp = yup.object({
  otp: yup.number().required('Please enter a valid OTP'),
});

const validationSchemaMobileOtpLogin = yup.object({
  phone: yup
    .string()
    .matches(/^\d{10}$/, 'Please enter a valid 10-digit mobile number')
    .required('Please enter your mobile number'),
});

const validationSchemaSetPassword = yup.object({
  password: yup
    .string()
    .required('Please enter your password')
    .matches(/^\S{6,32}$/, 'Password must be 6-32 characters with no spaces'),
  confirmPassword: yup
    .string()
    .required('Please enter your password')
    .oneOf(
      [yup.ref('password')],
      'The passwords you entered do not match. Please check and try again'
    ),
});

const validationSchemaParticipantRegistration = yup.object({
  name: yup.string().required('Please enter your name'),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),

  password: yup
    .string()
    .required('Please enter your password')
    .matches(/^\S{6,32}$/, 'Password must be 6-32 characters with no spaces'),
  gender: yup
    .string()
    .oneOf(['male', 'female'], 'Please select a valid gender')
    .required('Please select your gender'),
  expYear: yup
    .number()
    .positive('Years of experience must be a positive number')
    .integer()
    .required('Please enter your years of experience'),
  expMonth: yup
    .number()
    .positive('Months of experience must be a positive number')
    .integer()
    .required('Please enter your months of experience'),
  phone: yup
    .string()
    .matches(/^\d{10}$/, 'Phone number must be 10 digits')
    .required('Please enter your phone number'),
  // attachResume: yup.mixed().required('Please attach your resume'),
  instituteName: yup.string().required('Please enter your institute name'),
  passingYear: yup
    .number()
    .positive('Passing year must be a positive number')
    .integer()
    .required('Please enter your passing year'),
  functionalArea: yup.string().required('Please enter your functional area'),
  preferredCompany: yup
    .string()
    .required('Please enter your preferred company'),
});

export {
  validationSchemaLogin,
  validationSchemaSignUp,
  validationSchemaForgot,
  validationSchemaOtp,
  validationSchemaMobileOtpLogin,
  validationSchemaSetPassword,
  validationSchemaParticipantRegistration,
  validationSchemaSignUpHirist,
};
